import { ThreadCreatePayloadSchema } from '@varos/interview-schema';
import { z } from 'zod';
import { deserializeNewThreadOptions } from './threadNewSerdes';

export const ThreadNewUrlParamSchema = z.preprocess(
    (item) => {
        const data = deserializeNewThreadOptions(item as any);
        const { return_path, thread } = data;
        return {
            return_path,
            thread,
        };
    },
    z.object({
        return_path: z.string().nullable().default(null),
        thread: ThreadCreatePayloadSchema,
    })
);

export const ThreadNewFormValuesSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('session'),
        mode: z.enum(['text', 'voice']),
        confirmed: z.boolean(),
        email: z.string().email(),
    }),
    z.object({
        kind: z.literal('user'),
        mode: z.enum(['text', 'voice']),
        confirmed: z.boolean(),
        email: z.string().email().nullable().optional(),
    }),
]);
